import { getMktportalParams } from './mktportal';
import type { TrackingParamsRepository } from './types';
import { getUtmParameters } from './utm';

export const createTrackingParamsRepository = (): TrackingParamsRepository => {
  return {
    getUtmParams: getUtmParameters,
    getMktportalParams,
  };
};
